export {PageSlides} from './components/PageSlides';
export {SlideParallaxType} from './models/SlideParallaxType';
export {ISlideConfig} from './models/ISlideConfig';